import { useLocation } from 'react-router-dom';

export function TopBar() {
  const path = useLocation().pathname;
  if (path.startsWith('/subscription') || path.startsWith('/onboarding')) return null;
  return (
    <div className="flex items-center justify-center py-2 bg-bg shrink-0">
      <img src="/logo.jpeg" alt="Lura" className="h-auto w-[100px] rounded-lg object-contain" />
    </div>
  );
}
